<template>
    <div class="information-wrapper content-wrapper">
        <el-collapse v-model="headerActiveName" accordion>
            <el-collapse-item name="headerInfo">
                <template slot="title">
                    <div class="header-title">
                        <span class="header-title-block"></span>
                        <span class="header-title-txt">地址信息</span>
                    </div>
                </template>
                <el-divider></el-divider>
                <div class="addressInfo-container">
                    <el-card class="card-content">
                        <div slot="header" class="card-content-title">
                            <span>
                                发货信息
                                <el-tooltip class="item" effect="dark" content="点击跳转查看发车单详情" placement="top">
                                    <span class="copy-dispatch" @click="openDispatch">（发车单：{{formData.dispatchNo}}）</span>
                                </el-tooltip>
                            </span>
                        </div>
                        <el-form label-width="100px" label-position="left">
                            <el-form-item label="发货人：">
                                <span class="icon" :style="`background-image:url(${avatar})`"></span>
                                <span @dblclick="copyItem($event)">{{formData.senderName || '--'}}</span>
                                <span class="icon tel" :style="`background-image:url(${tel})`"></span>
                                <span>
                                    手机号码：<span @dblclick="copyItem($event)">{{formData.senderMobile || '--'}}</span>
                                    / 固定号码： <span @dblclick="copyItem($event)">{{formData.senderTel || '--'}}</span>
                                </span>
                            </el-form-item>
                            <el-form-item label="发货单位：">
                                <div class="item-value" @dblclick="copyItem($event)">{{ formData.upperSenderName || '--'}}</div>
                            </el-form-item>
                            <el-form-item label="发货地址：">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="getSenderInformation(formData)"
                                    placement="top-start"
                                    >
                                    <div class="item-value" @dblclick="copyItem($event)">{{ getSenderInformation(formData) }}</div>
                                </el-tooltip>
                            </el-form-item>
                        </el-form>
                    </el-card>

                    <el-card class="card-content">
                        <div slot="header" class="card-content-title">
                            <span>收货信息</span>
                        </div>
                        <el-form label-width="100px" label-position="left">
                            <el-form-item label="收货人：">
                                <span class="icon" :style="`background-image:url(${avatar})`"></span>
                                <span @dblclick="copyItem($event)">{{formData.receiverName || '--'}}</span>
                                <span class="icon tel" :style="`background-image:url(${tel})`"></span>
                                <span>
                                    手机号码：<span @dblclick="copyItem($event)">{{formData.receiverMobile || '--'}}</span>
                                    / 固定号码： <span @dblclick="copyItem($event)">{{formData.receiverTel || '--'}}</span>
                                </span>
                            </el-form-item>
                            <el-form-item label="收货单位：">
                                <div class="item-value" @dblclick="copyItem($event)">{{ formData.upperReceiverName || '--'}}</div>
                            </el-form-item>
                            <el-form-item label="收货地址：">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="getReceiverInformation(formData)"
                                    placement="top-start"
                                    >
                                    <div class="item-value" @dblclick="copyItem($event)">{{ getReceiverInformation(formData) }}</div>
                                </el-tooltip>
                            </el-form-item>
                        </el-form>
                    </el-card>

                    <el-card class="card-content">
                        <div slot="header" class="card-content-title">
                            <span>最终收货信息</span>
                        </div>
                        <el-form label-width="100px" label-position="left">
                            <el-form-item label="最终收件人：">
                                <span class="icon" :style="`background-image:url(${avatar})`"></span>
                                <span @dblclick="copyItem($event)">{{formData.finalName || '--'}}</span>
                                <span class="icon tel" :style="`background-image:url(${tel})`"></span>
                                <span>
                                    手机号码：<span @dblclick="copyItem($event)">{{formData.finalMobile || '--'}}</span>
                                    / 固定号码： <span @dblclick="copyItem($event)">{{formData.finalTel || '--'}}</span>
                                </span>
                            </el-form-item>
                            <el-form-item label="最终收件地址：">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="getFinalInformation(formData)"
                                    placement="top-start"
                                    >
                                    <div class="item-value" @dblclick="copyItem($event)">{{ getFinalInformation(formData) }}</div>
                                </el-tooltip>
                            </el-form-item>
                        </el-form>
                    </el-card>

                    <el-card class="card-content">
                        <div slot="header" class="card-content-title">
                            <span>网点信息</span>
                        </div>
                        <el-form label-width="100px" label-position="left">
                            <el-form-item label="联系人：">
                                <span class="icon" :style="`background-image:url(${avatar})`"></span>
                                <span @dblclick="copyItem($event)">{{formData.networkContact || '--'}}</span>
                                <span class="icon tel" :style="`background-image:url(${tel})`"></span>
                                <span @dblclick="copyItem($event)">{{formData.networkTel || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="网点名称：">
                                <div class="item-value" @dblclick="copyItem($event)">{{ formData.networkName || '--'}}</div>
                            </el-form-item>
                            <el-form-item label="网点地址：">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="formData.networkAddr"
                                    placement="top-start"
                                    >
                                    <div class="item-value" @dblclick="copyItem($event)">{{ formData.networkAddr || '--' }}</div>
                                </el-tooltip>
                            </el-form-item>
                        </el-form>
                    </el-card>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
import { copyToClip } from '../util.js';
export default {
    name: 'SenderInformation',
    props: {
        formData: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    computed: {
        // 发货地址信息
        getSenderInformation () {
            return function (formData) {
                const { senderProvinceName, senderCityName, senderDistrictName, senderTownName, senderDetailAddr, startLng, startLat } = formData;
                if (senderProvinceName || senderCityName || senderDistrictName || senderTownName || senderDetailAddr || startLng || startLat) {
                    const senderInfo = ['senderProvinceName', 'senderCityName', 'senderDistrictName', 'senderTownName', 'senderDetailAddr'].map(key => formData[key] || '-').join('/');
                    const LngAndLat = ['startLng', 'startLat'].map(key => formData[key] || '-').join('/');
                    return `${senderInfo}(${LngAndLat})`;
                } else {
                    return '--';
                };
            };
        },
        // 收货地址信息
        getReceiverInformation () {
            return function (formData) {
                const { receiverProvinceName, receiverCityName, receiverDistrictName, receiverTownName, receiverDetailAddr, endLng, LngAndLat } = formData;
                if (receiverProvinceName || receiverCityName || receiverDistrictName || receiverTownName || receiverDetailAddr || endLng || LngAndLat) {
                    const receiver = ['receiverProvinceName', 'receiverCityName', 'receiverDistrictName', 'receiverTownName', 'receiverDetailAddr'].map(key => formData[key] || '-').join('/');
                    const LngAndLat = ['endLng', 'endLat'].map(key => formData[key] || '-').join('/');
                    return `${receiver}(${LngAndLat})`;
                } else {
                    return '--';
                }
            };
        },
        // 最终收件地址信息
        getFinalInformation () {
            return function (formData) {
                const { finalProvinceName, finalCityName, finalDistrictName, finalTownName, finalDetailAddr } = formData;
                if (finalProvinceName || finalCityName || finalDistrictName || finalTownName || finalDetailAddr) {
                    return ['finalProvinceName', 'finalCityName', 'finalDistrictName', 'finalTownName', 'finalDetailAddr'].map(key => formData[key] || '无').join('/');
                } else {
                    return '--';
                }
            };
        }
    },
    data () {
        return {
            headerActiveName: 'headerInfo',
            avatar: require('@/assets/touxiang.png'),
            tel: require('@/assets/dianhua.png')
        };
    },
    methods: {
        copyItem (e) {
            const value = (e.target.innerHTML).trim();
            value !== '--' && copyToClip(value);
        },
        openDispatch () {
            this.$router.push({
                name: 'performanceDispatchOrder',
                params: {
                    dispatchNo: this.formData.dispatchNo
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.icon {
    display: inline-block;
    width: 12px;
    height: 12px;
    background-size:contain;
    background-position: center;
    background-repeat: no-repeat;
    margin-right: 3px;
}
.tel {
    margin-left: 30px;
}
</style>
